import PropTypes from 'prop-types';
import React from 'react';

import { suffix } from 'utils/OrdinalSuffix';

export default function Ordinal({n, superscriptSuffix = true}) {
  require("./Ordinal.scss");
  const suf = suffix(n);
  const renderedSuf = (suf && superscriptSuffix) ? <sup>{suf}</sup> : suf;

  return (
    <span className="ordinal">{n}{ renderedSuf }</span>
  );
}

Ordinal.propTypes = {
  n: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  superscriptSuffix: PropTypes.bool
}



// WEBPACK FOOTER //
// ./modules/Common/components/Ordinal.js